export default __webpack_public_path__ + "static/media/access_time.acf628d3.svg";